import React, { createContext, useContext, useState, useCallback } from 'react';

const PendingChangesContext = createContext(null);

export const PendingChangesProvider = ({ children }) => {
  const [isDirty, setIsDirty] = useState(false);
  const [saveHandler, setSaveHandler] = useState(null);
  const [clearHandler, setClearHandler] = useState(null);

  const registerHandlers = useCallback((save, clear) => {
    setSaveHandler(() => save);
    setClearHandler(() => clear);
  }, []);

  const unregisterHandlers = useCallback(() => {
    setSaveHandler(null);
    setClearHandler(null);
    setIsDirty(false);
  }, []);

  const value = {
    isDirty,
    setIsDirty,
    saveHandler,
    clearHandler,
    registerHandlers,
    unregisterHandlers,
  };

  return (
    <PendingChangesContext.Provider value={value}>
      {children}
    </PendingChangesContext.Provider>
  );
};

export const usePendingChangesContext = () => {
  const context = useContext(PendingChangesContext);
  if (!context) {
    throw new Error('usePendingChangesContext must be used within a PendingChangesProvider');
  }
  return context;
};

export default PendingChangesContext;
